import {
    PORTRAIT_ORIENTATION,
    LANDSCAPE_ORIENTATION,
    OPEN_PRINT_PREVIEW,
    CLOSE_PRINT_PREVIEW,
} from 'redux/print/actions'
import { set } from 'immutadot'

const initialState = {
    isOpened: false,
    orientation: 'portrait',
}

export const print = (state = initialState, {type}) => {
    switch (type)
    {
        case OPEN_PRINT_PREVIEW:
            return set(state, 'isOpened', true)

        case CLOSE_PRINT_PREVIEW:
            return set(state, 'isOpened', false)

        case PORTRAIT_ORIENTATION:
            return set(state, 'orientation', 'portrait')

        case LANDSCAPE_ORIENTATION:
            return set(state, 'orientation', 'landscape')

        default:
            return state
    }
}
